module.exports = __webpack_public_path__ + "img/btn_google_dark_disabled_ios.3c96331c.svg";